import { getAssignedDataGroup } from "../../../../../core/router/auth";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { FormMutation } from "../../../../../core/service/types/FormMutation";
import type { TerminalPasswordEntity } from "../../types/TerminalPasswordEntity";
import { TerminalPasswordEntityToDto } from "../mappers/TerminalPasswordEntityToDto";

const TerminalPasswordApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        TerminalPasswordSave: builder.mutation<TerminalPasswordEntity, FormMutation<TerminalPasswordEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.TERMINAL_PASSWORD}`;
                const method = "POST";

                const body = TerminalPasswordEntityToDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: [ResourceName.TERMINAL_PASSWORD],
        }),
    }),
});

export const { useTerminalPasswordSaveMutation } = TerminalPasswordApi;
